import { render, staticRenderFns } from "./kongbai.vue?vue&type=template&id=1a61319e&"
import script from "./kongbai.vue?vue&type=script&lang=js&"
export * from "./kongbai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports